"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_VisionPrescription_Prism = exports.VisionPrescription_PrismBaseKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var RTTI_Element_1 = require("./RTTI_Element");
var VisionPrescription_PrismBaseKind;
(function (VisionPrescription_PrismBaseKind) {
    VisionPrescription_PrismBaseKind["_up"] = "up";
    VisionPrescription_PrismBaseKind["_down"] = "down";
    VisionPrescription_PrismBaseKind["_in"] = "in";
    VisionPrescription_PrismBaseKind["_out"] = "out";
})(VisionPrescription_PrismBaseKind = exports.VisionPrescription_PrismBaseKind || (exports.VisionPrescription_PrismBaseKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_VisionPrescription_Prism = t.recursion('IVisionPrescription_Prism', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        amount: RTTI_decimal_1.RTTI_decimal,
        _amount: RTTI_Element_1.RTTI_Element,
        base: (0, EnumType_1.createEnumType)(VisionPrescription_PrismBaseKind, 'VisionPrescription_PrismBaseKind'),
        _base: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_VisionPrescription_Prism.js.map